// extracted by mini-css-extract-plugin
module.exports = {"newsroom-banner-box":"h","newsroomBannerBox":"h","newsroomBannerLeft":"i","newsroomBannerRight":"j"};